define(["require", "exports", "./Dimension", "./Border"], function (require, exports, Dimension_1, Border_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PhysicalScreen = (function () {
        function PhysicalScreen() {
            this.LocationId = "";
            this.Name = "";
            this.Vendor = "";
            this.Model = "";
            this.SerialNumber = "";
            this.RemoteControlSerialNumber = "";
            this.Serial = null;
            this.Dimension = new Dimension_1.Dimension();
            this.Border = new Border_1.Border();
            this.Resolution = new Dimension_1.Dimension();
            this.Dpi = 0;
            this.AVBoxesIds = [];
            this.AV2Boxes = [];
            this.Comment = "";
            this.InventoryNumber = "";
        }
        return PhysicalScreen;
    }());
    exports.PhysicalScreen = PhysicalScreen;
    var SerialParameter = (function () {
        function SerialParameter() {
            this.BaudRate = 9600;
            this.CharSize = 8;
            this.StopBits = 1;
            this.Parity = "None";
            this.FlowControl = "None";
            this.Protocol = null;
        }
        return SerialParameter;
    }());
    exports.SerialParameter = SerialParameter;
});
//# sourceMappingURL=PhysicalScreen.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Configuration/PhysicalScreen.js
// module id = 109
// module chunks = 0